import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import styles from './CheckPlace24hModal.module.scss';

const CheckPlace24hModalContent = () => (
  <div className={styles['check-place-24h-modal__body']}>
    <p>{trans('check.place.24h.modal.description')}</p>

    <div>
      <h5 className={styles['check-place-24h-modal__conditions-title']}>
        {trans('check.place.24h.modal.conditions1')}
      </h5>
      <ul className={styles['check-place-24h-modal__conditions-list']}>
        <li>{trans('check.place.24h.modal.conditions1.item1')}</li>
        <li>{trans('check.place.24h.modal.conditions1.item2')}</li>
        <li>{trans('check.place.24h.modal.conditions1.item3')}</li>
      </ul>
    </div>

    <div>
      <h5 className={styles['check-place-24h-modal__conditions-title']}>
        {trans('check.place.24h.modal.conditions2')}
      </h5>
      <p>{trans('check.place.24h.modal.conditions2.item1')}</p>
    </div>
  </div>
);

const openCheckPlace24hModal = () => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: (
      <>
        <DSIcon name="mystery" size="ml" />
        <br />
        {trans('check.place.24h.modal.title')}
      </>
    ),
    body: <CheckPlace24hModalContent />,
    fullscreenOnMobile: true
  });
};

export default openCheckPlace24hModal;
